import { useEffect, useState } from "react";
import AdsterraBanner from "./AdsterraBanner";
import "./BottomAdBar.css";

const LEADERBOARD_KEY = "c175836ceeb3bd65ff418b31597943d6";
// The ad itself is 728px wide; below that a bottom bar would either clip it
// or force horizontal scroll, so it's skipped on narrow screens.
const MIN_WIDTH = 780;
const DISMISS_KEY = "epsviewer_bottom_ad_dismissed";

export default function BottomAdBar() {
  const [wide, setWide] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= MIN_WIDTH
  );
  const [dismissed, setDismissed] = useState(
    () => typeof window !== "undefined" && sessionStorage.getItem(DISMISS_KEY) === "1"
  );

  useEffect(() => {
    const onResize = () => setWide(window.innerWidth >= MIN_WIDTH);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (!wide || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="bottom-ad-bar">
      <span className="bottom-ad-bar__label">Advertisement</span>
      <AdsterraBanner adKey={LEADERBOARD_KEY} width={728} height={90} />
      <button
        type="button"
        className="bottom-ad-bar__close"
        aria-label="Close advertisement"
        onClick={dismiss}
      >
        ×
      </button>
    </div>
  );
}
